import React from 'react'
import {Routes,Route} from 'react-router-dom';
import Dashboard from './Dashboard';

const DashboardView= (props:any) => {
  const userHasChangePassword = props.data;
  const setUserHasChangePassword = props.onChange;
  return (
     <Routes>
       <Route path="*" element={<Dashboard data={userHasChangePassword} onChange={setUserHasChangePassword}/>} />
     </Routes>
  )
}

export default DashboardView

export {default as NavBar} from './NavBar';
export {default as SideBar} from './SideBar';

// NOTE: page modules (Applicants, Settings, Approvals, Payment, Reports, etc.)
// are intentionally NOT re-exported here. Dashboard.tsx loads them via
// React.lazy() for route-based code splitting — eagerly re-exporting them
// from this barrel file would pull every page into the initial bundle and
// defeat that code splitting.